export function navigatePage(url, openNewTab = false) {
  // We check for FF here because it is very aggressive about blocking usage of
  // window.open that is not a direct result of user interaction. This can be
  // triggered by an iframe event, so this usage doesn't fit the bill. For FF,
  // we will just disable opening in new tab to work around this.
  const isFirefox = window.navigator.userAgent.includes('Firefox');
  if (!isFirefox && openNewTab) {
    window.open(url, '_blank', 'noopener');
  } else {
    window.location.assign(url);
  }
}
export function openPageInNewTab(url) {
  window.open(url, '_blank', 'noopener');
}